import { render, staticRenderFns } from "./PdfTranslate.vue?vue&type=template&id=3cc85a92&scoped=true"
import script from "./PdfTranslate.vue?vue&type=script&lang=js"
export * from "./PdfTranslate.vue?vue&type=script&lang=js"
import style0 from "./PdfTranslate.vue?vue&type=style&index=0&id=3cc85a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc85a92",
  null
  
)

export default component.exports